interface AvatarProps {
  src?: string | null;
  firstName?: string;
  lastName?: string;
  size?: string;
  className?: string;
  style?: React.CSSProperties;
  imgClassName?: string;
}

const FONT_SIZES: Record<string, string> = {
  "avatar-xl": "1.25rem",
  "avatar-lg": "1rem",
  "avatar-sm": "0.65rem",
  "avatar-xs": "0.55rem",
  "header-profile-user": "0.75rem",
};

const Avatar = ({
  src,
  firstName = "",
  lastName = "",
  size = "",
  className = "",
  style,
  imgClassName,
}: AvatarProps) => {
  const initials = firstName.charAt(0).toUpperCase() || "?";
  const fontSize = FONT_SIZES[size] ?? "1rem";

  if (src) {
    return (
      <img
        src={src}
        alt={`${firstName} ${lastName}`}
        className={`rounded-circle ${size} ${imgClassName ?? ""} ${className}`.trim()}
        style={style}
      />
    );
  }

  // Nested structure: outer div holds the size, inner span fills it
  return (
    <div className={`${size} ${className}`.trim()} style={style}>
      <span
        className="avatar-title rounded-circle fw-bold"
        style={{ background: "#6c757d", color: "#fff", fontSize }}
      >
        {initials}
      </span>
    </div>
  );
};

export default Avatar;
